import moment from 'moment-jalaali'
export const createCalendar = (moment, year) => {
    const faDayWeek = {

        '0': 'یکشنبه', '1': 'دوشنبه', '2': 'سه‌شنبه', '3': 'چهارشنبه', '4': 'پنج‌شنبه', '5': 'جمعه', '6': 'شنبه',
    }


    let tempList = []
    if (moment) {
        for (let i = 0; i < 12; i++) {
            let dayCount = moment.jDaysInMonth(year, i)
            // let dayCount = moment(`${year}-${i}`, "YYYY-M").daysInMonth()


            let temp = { month: monthNames(i + 1), days: [] }
            debugger
            for (let j = 0; j < dayCount; j++) {
                let m = moment().jYear(year).jMonth(i).jDate(j + 1)
                const dayNumber = parseInt(m.locale('fa').format('d'))
                if (j === 0 && dayNumber !== 6) {
                    for (let i = 0; i < dayNumber + 1; i++) {
                        temp.days.unshift({
                            name: "",
                            dateStr: "",
                            dayNumber: 0,
                            day: '',
                            jalaliName: "",
                            isWeeklyHoliday: false,
                            isAnnualHoliday: false,
                            annualHolidayReason: "",
                            year

                        })

                    }
                }
                let tempModel = {
                    name: faDayWeek[m.locale('fa').format('d')],
                    dateStr: m.format("jYYYY/jMM/jDD"),
                    dayNumber: dayNumber,
                    day: j + 1,
                    jalaliName: "",
                    isWeeklyHoliday: false,
                    isAnnualHoliday: false,
                    annualHolidayReason: "",
                    monthName: temp.month
                }
                temp.days.push(tempModel)

            }
            tempList.push(temp)
        }

    }

    return tempList

}
export const getDateOfTimeZoneDate = (date) => {
    return date.split('T')[0]
}

export const returnSeparatedDayMonth = (timeZoneDate) => {
    const m = moment(getDateOfTimeZoneDate(timeZoneDate), 'YYYY-MM-DD')
    const month = (m.jMonth() + 1).toString()
    const day = m.jDate()
    return { month, day };
}

export const getEnDate = (persianDateStr) => {
    return moment(persianDateStr, "jYYYY/jMM/jDD").locale('en').format('YYYY-MM-DD')
}
export const monthNames = (m) => {
    return {
        '1': "فروردین",
        '2': "اردیبهشت",
        '3': "خرداد",
        '4': "تیر",
        '5': "مرداد",
        '6': "شهریور",
        '7': "مهر",
        '8': "آبان",
        '9': "آذر",
        '10': "دی",
        '11': "بهمن",
        '12': "اسفند"
    }[m]

}

export const tableHead = ['ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج', 'ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج', 'ش', 'ی', 'د', 'س', 'چ', 'پ',
    'ج', 'ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج', 'ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج', 'ش', 'ی']
export const annualHoliday1402 = [{ date: "1402/01/01", description: "" },
{ date: "1402/01/02", description: "" }, { date: "1402/01/03", description: "" }, { date: "1402/01/04", description: "" },
{ date: "1402/01/12", description: "" }, { date: "1402/01/13", description: "" },
{ date: "1402/02/03", description: "" },
{ date: "1402/02/12", description: "" }, { date: "1402/02/13", description: "" }, { date: "1402/03/05", description: "" },
{ date: "1402/03/14", description: "" }, { date: "1402/03/15", description: "" }, { date: "1402/04/19", description: "" },
{ date: "1402/04/27", description: "" },
{ date: "1402/05/16", description: "" },
{ date: "1402/05/17", description: "" }, { date: "1402/06/26", description: "" }, { date: "1402/07/03", description: "" },
{ date: "1402/07/05", description: "" }, { date: "1402/07/13", description: "" }, { date: "1402/07/22", description: "" },
{ date: "1402/10/06", description: "" },
{ date: "1402/11/15", description: "" },
{ date: "1402/11/22", description: "" }, { date: "1402/12/17", description: "" }, { date: "1402/12/29", description: "" }]


export const enToPersianChar = (str) => {
    var pn = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    var en = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

    var temp = str + "";
    for (var i = 0; i < 10; i++) {
        var regex_en = new RegExp(en[i], 'g');
        temp = temp.replace(regex_en, pn[i]);
    }
    return temp
}

export const getDateYear = (date) => {
    return moment(date, 'YYYY-MM-DD').locale('fa').format('jYYYY')
}